var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown-area"},[_c('div',{staticClass:"countdown",class:{ 'color-yellow': _vm.lastMinute, 'color-red': _vm.LastThirtySec }},[_c('div',[_vm._v(_vm._s(_vm.menssagem))])])])}
var staticRenderFns = []

export { render, staticRenderFns }